import { render } from "./VueProgressBar.vue?vue&type=template&id=f21222e8&scoped=true&ts=true"
import script from "./VueProgressBar.vue?vue&type=script&lang=ts"
export * from "./VueProgressBar.vue?vue&type=script&lang=ts"

import "./VueProgressBar.vue?vue&type=style&index=0&id=f21222e8&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f21222e8"]])

export default __exports__